<!-- side-menu.component.html -->
<ion-content>
  <div class="d-flex flex-column justify-content-between menus-container">
    <ion-list class="side-menu-items">
      <ng-content select="[top]"></ng-content>

      <ng-container *ngFor="let item of menuItems; let i = index">
        <ion-item
          lines="none"
          button
          detail="false"
          [routerLink]="item.enabled ? item.link : null"
          (click)="
            item.enabled
              ? onItemClick($event, item, i)
              : displayNotSubscribedMessage(item.functionality_name)
          "
          [ngClass]="{ 'active': selectedMenuItemIndex === i }"
        >
          <ng-container *ngIf="item.iconSource === 'bootstrap'; else ionicIcon">
            <i class="bi" [ngClass]="'bi-' + item?.iconName" slot="start"></i>
          </ng-container>
          <ng-template #ionicIcon>
            <ion-icon [name]="item?.iconName" slot="start"></ion-icon>
          </ng-template>

          <ion-label class="d-flex flex-column ion-text-capitalize" *ngIf="menuState === 'expanded' ">
            <span [innerText]="item.name"></span>
            <small *ngIf="item.label" [innerText]="item.label"></small>
          </ion-label>

          <ion-badge
            *ngIf="item.badge"
            [innerText]="item.badge.count"
            [color]="item.badge.color"
          ></ion-badge>
        </ion-item>
      </ng-container>

      <div class="spacer"></div>
      <ng-content select="[bottom]" class="collapsed-btn"></ng-content>
    </ion-list>
  </div>
</ion-content>
